import { render, staticRenderFns } from "./PoliceMedicalExemption.vue?vue&type=template&id=fe00fc00&scoped=true&"
import script from "./PoliceMedicalExemption.vue?vue&type=script&lang=js&"
export * from "./PoliceMedicalExemption.vue?vue&type=script&lang=js&"
import style0 from "./PoliceMedicalExemption.vue?vue&type=style&index=0&id=fe00fc00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe00fc00",
  null
  
)

export default component.exports